import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { getRoundFromIdAtom } from "../getRoundFromIdAtom/getRoundFromIdAtom";

export const getRateFromRoundIdAtom = atomFamily((roundId: string) => {
  return atom((get) => {
    const round = get(getRoundFromIdAtom(roundId));
    const rate =
      round?.type === "Golf" ? round?.roundRate : round?.rate ?? null;
    return rate;
  });
});
